export default __webpack_public_path__ + "static/media/627.76a59f87.png";